import { DEFAULT_PAGINATION } from 'core/constants/pagination.constants';
import { IUserParams } from 'core/model/interfaces/users';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { removeEmptyValues } from 'shared/utils/object.utils';
import { SLICE_NAMESPACE } from '../constants';
import type { IUsersState } from '../types';

export const fetchUserList = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/fetchUserList`,
  async (params: IUserParams, { getState }) => {
    const { users } = getState();
    return apiService.users.getUserList(
      removeEmptyValues({
        ...params,
        page: users.userList.pagination.currentPage,
      }),
    );
  },
);

export const fetchUserListReducer: TSliceExtraReducer<IUsersState> = builder =>
  builder
    .addCase(fetchUserList.pending, state => {
      state.userList.isLoading = true;
    })
    .addCase(fetchUserList.rejected, state => {
      state.userList.isLoading = false;
      state.userList.pagination = DEFAULT_PAGINATION;
      state.userList.data = [];
    })
    .addCase(fetchUserList.fulfilled, (state, { payload }) => {
      state.userList.data = payload.users;
      state.userList.pagination = payload.pagination;
      state.userList.isLoading = false;
    });
